import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import { formatCurrency } from 'client/utils/formatter';
import React from 'react';
import { colors, P12, P14 } from '../typography';
import modelCodes from 'client/constants/modelCode';

export type PriceSummaryProps = {
  modelCode: string;
  basePrice: number;
  options: {
    categoryName: string;
    code: string;
    name: string;
    price: number
  }[],
}

function DetailItem(props) {
  const {
    title,
    description,
    price,
  } = props;
  return (
    <DetailItemContainer>
      <Left>
        <P14>{title}</P14>
        <DetailItemDescription>{description}</DetailItemDescription>
      </Left>
      <P14 alignSelf='center'>{price}</P14>
    </DetailItemContainer>
  );
}

export default function PriceSummary(props: PriceSummaryProps) {
  const {
    modelCode,
    basePrice,
    options,
  } = props;

  const detailItems: {title: string, description?: string, price: string}[] = [];

  // base price
  detailItems.push({
    title: 'Base Price',
    description: '',
    price: formatCurrency(basePrice),
  });

  // options price
  options.forEach(op => {
    detailItems.push({
      title: op.categoryName,
      description: op.name,
      price: formatCurrency(op.price),
    });
  });

  // charging items prices
  if(modelCode === modelCodes.FF91FuturistAlliance.fullModelCode){
    detailItems.push({
      title: 'Home Charger',
      price: formatCurrency(0),
    });
  }
  detailItems.push({
    title: 'Public Charging Credit',
    price: formatCurrency(0),
  });
  detailItems.push({
    title: 'FF Portable Charging Cable',
    price: formatCurrency(0),
  });

  return (
    <Container>
      {detailItems.map(di => (
        <DetailItem key={di.title} {...di} />
      ))}
    </Container>
  );
}

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: '12px',
});

const DetailItemContainer = styled(Box)({
  display: 'flex',
  gap: '60px',
  justifyContent: 'space-between',
});

const DetailItemDescription = styled(P12)({
  marginTop: '5px',
  lineHeight: '20px',
  color: colors.content1,
});

const Left = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'left',
})
